import { render, staticRenderFns } from "./ContactSelectionBubble.vue?vue&type=template&id=c340fb32&scoped=true&"
import script from "./ContactSelectionBubble.vue?vue&type=script&lang=js&"
export * from "./ContactSelectionBubble.vue?vue&type=script&lang=js&"
import style0 from "./ContactSelectionBubble.vue?vue&type=style&index=0&id=c340fb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c340fb32",
  null
  
)

export default component.exports